import {
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
    makeStyles, Button,
} from "@fluentui/react-components"

interface AlertDialogProps {
    title: string;
    description: string;
    isOpen: boolean;
    onClose: () => void;
}

const useStyles = makeStyles({
    description: {
        whiteSpace: 'pre-line',
        fontSize: '14px',
        lineHeight: '20px',
        marginTop: '8px'
    },
    roundBtn: {
        backgroundColor: 'black',
        padding: '10px',
        borderRadius: '10px',
        fontSize: '15px',
        border: '0px',
        color:'white'
    },

})

export default function AlertDialog({ title, description, isOpen, onClose }: AlertDialogProps) {
    const styles = useStyles()

    return (
        <Dialog open={isOpen} onOpenChange={onClose} >
            <DialogSurface>
                <DialogBody>
                    <DialogTitle >{title}</DialogTitle>
                    <DialogContent>
                        <div className={styles.description} style={{fontSize: 'large'}}>
                            {description}
                        </div>
                        <div style={{display: 'flex', gap: "5px", justifyContent: 'center'}}>
                            <Button onClick={onClose} className={styles.roundBtn} style={{
                                backgroundColor: 'white',
                                color: 'black',
                                border: 'black 1px solid',
                                marginTop: '20px'
                            }}>닫기</Button>
                        </div>
                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}